/* eslint-disable react-hooks/rules-of-hooks */
import React, { JSX } from 'react';
import {
  Loader,
  LoginBox,
  LoginFooter,
  LoginWrapper,
  GoBackToLogin,
} from './styles';
import { LeftArrow } from '../../assets/icons/icons';
import loader from '../../assets/lottieFiles/loader.json';
import { useNavigate } from 'react-router-dom';

export default ({
  isHistory,
  isLoading,
  children,
  topLoader = 120,
}: {
  isHistory?: boolean,
  isLoading?: boolean,
  topLoader?: number,
  children: JSX.Element | JSX.Element[],
}) => {
  const navigate = useNavigate();

  return (
    <>
      <LoginWrapper>
        <LoginBox>
          {isLoading && (
            <Loader
              loop={true}
              src={loader}
              autoplay={true}
              topLoader={topLoader}
            />
          )}
          {isHistory && (
            <GoBackToLogin onClick={() => navigate(-1)}>
              <LeftArrow color="#2B323B" />
            </GoBackToLogin>
          )}
          {children}
        </LoginBox>
      </LoginWrapper>
      <LoginFooter>© 2020 ArmCare.com All Rights Reserved.</LoginFooter>
    </>
  );
};
